module.exports = __webpack_public_path__ + "media/images/add_box_icon-8fe0f864e65484cf874046b0217dee50.svg";